module.exports = __webpack_public_path__ + "media/speakers/conference@1x-330d391b.png";